import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_PF_SETTINGS);

const _pk_name = "id";

const state = {
    data: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};
const getters = {
    getPfData: (state) => {
        return state.data;
    }
};
const mutations = {
    set: (state, [payload, id]) => {
        state.data[id] = payload;
    },

    updateData: (state, [payload, le_id]) => {
        state.data[le_id] = payload;
    },
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {
    async fetchAll({ commit }, le_id) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`, {
                params: { le_id: le_id }
            });
            commit("setFetching", false);
            if (res.data.status) {
                commit("set", [res.data.payload.data, le_id]); //todo: Check for Pagination
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            if (res.data.status) {
                commit("set", [res.data.payload.data, payload.data.le_id]);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put('/', payload);
            commit("setSaving", false);
            if (res.data.status) {
                commit("updateData", [res.data.payload.data, payload.data.le_id]);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}